<template>
  <div class="approval">
    <div class="list">
      <div class="title">{{currentMenu.label}}</div>
      <el-form :inline="true" :model="queryParams" class="demo-form-inline" size="small">
        <el-form-item label="审批模板">
          <el-select v-model="queryParams.cfappId" placeholder="请选择审批模板" @change="onSubmit" clearable>
            <el-option v-for="item in cfappList" :key="item.cfAppId" :label="item.name" :value="item.cfAppId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动">
          <el-input v-model="queryParams.ofoworkName" placeholder="请输入活动名称" @change="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" placeholder="请选择状态" @change="onSubmit" clearable>
            <el-option v-for="item in dropDown.appStatus" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发起岗位">
          <el-input v-model="queryParams.ofrresourceName" placeholder="请输入发起岗位" @change="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="发起人">
          <el-input v-model="queryParams.ofrthingName" placeholder="请输入发起人" @change="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="发起时间">
          <el-date-picker
            v-model="date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="onSubmit">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审批时间">
          <el-date-picker
            v-model="date2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="onSubmit">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div style="margin-bottom: 1em" v-if="currentMenu.label === '待我审批'">
        <el-button plain type="primary" size="small" @click="doApproval()">批量审批</el-button>
      </div>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="loading"
        ref="table"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        @expand-change="expandChange"
      >
        <el-table-column type="selection" width="55" v-if="currentMenu.label === '待我审批'"> </el-table-column>
        <el-table-column prop="cfappName" label="审批模板" width="120"></el-table-column>
        <el-table-column prop="ofoworkName" label="活动" align="center" width="160">
          <template slot-scope="scope">
            <a @click="goProject(scope.row)" class="link">{{scope.row.ofoworkName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="nowStep" label="当前步骤" align="center" width="80">
          <template slot-scope="scope">
            <a @click="handleExpand(scope.row)" class="step">{{scope.row.nowStep}}</a>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <productView :key="scope.row.osAppId + '-' + productViewKey" style="width: calc(100vw - 290px);margin-left:150px" max-height="250" :ofoFlowWork="scope.row.workDetail.ofoFlowWork || {}" :ofoFlowDeal="scope.row.workDetail.ofoFlowDeal || {}" :productsList="scope.row.workDetail.productsList || []" :thingsList="scope.row.workDetail.thingsList ||[]" :workConfig="scope.row.workDetail.workConfig || {}" />
            <el-table border :data="scope.row.stepData" style="width: calc(100vw - 290px);margin-left:150px" max-height="250">
              <el-table-column prop="order" label="步骤" align="center" width="50"/>
              <el-table-column prop="ofrthingName" label="审批人" align="center" width="150"/>
              <el-table-column prop="appstatus" label="状态" align="center" width="100">
                <template slot-scope="scope">
                  <DictTag :options="dropDown.appStatus" :value="scope.row.appstatus" :isStyle="true" v-if="scope.row.steptype == '1' || scope.row.steptype == '9' "/>
                  <span v-if="scope.row.steptype == '2'" style="color: #909399;background-color: #f4f4f5;padding: 0 10px; font-size: 12px;height: 32px;display:inline-block;line-height:32px;border-radius:4px; border: 1px solid #e9e9eb">抄送</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" width="180">
                <template slot-scope="scope">
                  {{scope.row.createTime | filter_handleDateTime}}
                </template>
              </el-table-column>
              <el-table-column label="审批时间" align="center" width="180">
                <template slot-scope="scope">
                  {{scope.row.updateTime | filter_handleDateTime}}
                </template>
              </el-table-column>
              <el-table-column
                label="签名"
                align="center">
                <template slot-scope="scope">
                  <img :src="$base_url + scope.row.signUrl" alt="" style="width:30px;transform: rotate(-90deg)" />
                </template>
              </el-table-column>
              <el-table-column
                label="审批途径"
                align="center">
                <template slot-scope="scope">
                  {{scope.row.way == '0' ? '电脑端' : (scope.row.way == '1' ? '小程序' : '')}}
                </template>
              </el-table-column>
              <el-table-column prop="remarks" label="审批意见" align="center" show-overflow-tooltip>

                <template slot-scope="scope">
                  <div id="editor-content-view" class="editor-content-view" v-html="scope.row.remarks"></div>
                </template>

              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
                v-if="currentMenu.appstatus == '3'">
                <template slot-scope="scope" v-if="(scope.row.isApp == '1' || scope.row.isApp == '3') && scope.row.appstatus == '3'">
                  <el-form size="mini">
                    <el-button type="primary" size="mini" plain @click="handleAudit(scope.row)">审批</el-button>
                  </el-form>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="appstatus" label="状态" align="center" width="100">
          <template slot-scope="scope">
            <DictTag :options="dropDown.appStatus" :value="scope.row.appstatus" :isStyle="true"/>
          </template>
        </el-table-column>
        <el-table-column prop="ofrresourceName" label="发起岗位" align="center" width="150"></el-table-column>
        <el-table-column prop="ofrthingName" label="发起人" align="center" width="150"></el-table-column>
        <el-table-column prop="createTime" label="发起时间" width="180" align="center">
          <template slot-scope="scope">
            {{scope.row.createTime | filter_handleDateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="approvalTime" label="审批时间" width="180" align="center">
          <template slot-scope="scope">
            {{scope.row.approvalTime | filter_handleDateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="意见" show-overflow-tooltip align="center"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog v-dialog-drag
      title="审批"
      :visible.sync="dialogFromVisible"
      width="1000"
      append-to-body
      top="59px" >
        <el-form :model="form" label-width="70px">
          <el-form-item label="审批结果">
            <el-select v-model="form.appstatus" style="width: 100%">
              <el-option label="同意" value="1"></el-option>
              <el-option label="不同意" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批人" v-if="isShowSprs">
            <el-select v-model="form.sprs" placeholder="请选择下一步审批人" style="width:100%" filterable multiple >
              <el-option-group
                v-for="group in chooseList"
                :key="group.ofrResourceId"
                :label="group.resourceName">
                <el-option
                  v-for="item in group.ofrThingList"
                  :key="item.ofrThingId"
                  :label="item.name"
                  :value="item.ofrThingId">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="审批意见">
            <!-- <el-input type="textarea" :rows="3" placeholder="审批意见" v-model="form.remarks"></el-input> -->
             <div style="border: 1px solid #ccc;">
              <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
                />
                <Editor
                  style="height: 500px; overflow-y: hidden;"
                  v-model="form.remarks"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                />
              </div>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-form>
        <el-button type="primary" @click="submitAudit" :disabled="false">提 交</el-button>
        </el-form>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import DictTag from '@/components/DictTag.vue'
import { mapState } from 'vuex'
import qs from 'qs'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import Vue from 'vue'
import handleWorkConfigList from '@/utils/handleWorkConfigList'
import ProductView from "@/components/project/activity/productView.vue";
// import { DomEditor } from '@wangeditor/editor'
// const toolbar = DomEditor.getToolbar(editor)

// const curToolbarConfig = toolbar.getConfig()
// console.log( curToolbarConfig.toolbarKeys ) // 当前菜单排序和分组
let v = new Vue();
const editorConfig = {                       // JS 语法
    MENU_CONF: {}

    // 其他属性...
}
// console.log(v.$base_url);
// 修改 uploadImage 菜单配置
editorConfig.MENU_CONF['uploadImage'] = {
  server: v.$base_url + '/api/utils/uploadFile',
  fieldName: 'file',
  headers: {
    token: window.sessionStorage.getItem('token')
  },
  customInsert(res, insertFn) {
    insertFn(v.$base_url + res.data)
  },
}
// const toolbar = Toolbar.getToolbar(Editor)

// const curToolbarConfig = toolbar.getConfig()
// console.log( curToolbarConfig.toolbarKeys )
const toolbarConfig = {                        // JS 语法
  /* 工具栏配置 */
  excludeKeys: [
    "group-video"
  ]

}
  export default {
    components: {
      ProductView,
      DictTag,
      Editor,
      Toolbar
    },
    name: 'approval',
    data() {
      return {
        tableData: [],
        pageNum: 1,
        productViewKey: 1,
        pageSize: 10,
        total: 0,
        loading: true,
        form: {
          appstatus: '1',
          remarks: '',
          osAppStepId: '',
          sprs: []
        },
        dialogFromVisible: false,
        data: {},
        menuList: JSON.parse(sessionStorage.getItem('menuList')),
        chooseList: [],
        isShowSprs: false,
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: toolbarConfig,
        editorConfig: editorConfig,
        mode: 'default', // or 'simple'
        queryParams: {
          cfappId: null,
          ofoworkName: null,
          status: null,
          ofrresourceName: null,
          ofrthingName: null
        },
        cfappList: [],
        date: [],
        date2: []
      }
    },
    computed: {
      ...mapState ({
        dropDown: state => state.dropDown.dropDown,
        currentMenu: (state) => state.tags.currentMenu,
      })
    },
    created() {
      // console.log(this.$route);
      this.$http.get(url.getCfAppList, {params: {
        pageNum: 1,
        pageSize: 2000
      }}).then(res => {
        if(res.data.code == 200) {
          this.cfappList = res.data.data.list
        }
      })
      this.getList()
    },
    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    methods: {
      doApproval () {
        const datas = this.$refs.table.selection
        if(!datas || datas.length < 1) {
          this.$message.error('未选择数据')
          return
        }
        const ids = datas.map(item => item.osAppId)
        this.$confirm('确定进行批量审批吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.batchSubmitOsApp + '/' + ids.join()).then(res => {
            if(res.data.code == 200) {
              this.$message({
                type: 'success',
                message: res.data.msg
              });
              this.getList()
            }
          })
        }).catch(() => {

        });

      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      handleAudit(row) {
        this.isShowSprs = row.isApp == '3'
        this.dialogFromVisible = true
        // console.log(this.$refs);
        this.form.appstatus = '1'
        this.form.remarks = ''
        this.form.sprs = []
        this.form.osAppStepId = row.osAppStepId
        this.chooseList = row.chooseList ? row.chooseList : []
      },
      submitAudit() {
        let obj = Object.assign({}, this.form)
        obj.sprs = this.form.sprs.toString()
        obj.way = '0'
        this.$http.post(url.submitOsApp, qs.stringify(obj)).then(res => {
          if(res.data.code == 200) {
            this.$message({
              type: 'success',
              message: res.data.msg
            });
            this.dialogFromVisible = false
            this.getList()
          }
        })
      },
      getList() {
        this.loading = true
        this.$http.get(url.getMyOsApp, {params: {
          appstatus: this.currentMenu.appstatus,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.queryParams,
          beginTime: this.date.length ? this.date[0] : null,
          endTime: this.date.length ? this.date[1] : null,
          approvalBegin: this.date2.length ? this.date2[0] : null,
          approvalEnd: this.date2.length ? this.date2[1] : null
        }}).then(res => {
          if(res.data.code == 200) {
            this.total = res.data.data.total
            if(res.data.data.list) {
              res.data.data.list.map(item => {
                let stepData = []
                item['stepData'] = stepData
              })
              this.tableData = res.data.data.list
            }else {
              this.tableData = []
            }
            this.loading = false
            // this.$eventBus.$emit('getApprovalCount', res.data.data.total)
          }
        })
        if(!this.dropDown.appStatus) {
          this.$http.get(url.getDataList, {params: {type: 'buss_app_status' }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setAppStatus', res.data.data)
            }
          })
        }
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.pageNum = 1
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      goProject(row) {
        // console.log(row);
        this.$http.get(url.getWorkJumpId, {params: {ofoWorkId: row.ofoworkId}}).then(res => {
          // console.log(res);
          if(res.data.code == 200) {
            this.$router.push({
              path: '/project/' + res.data.data.ofoItemId,
            });
            this.data = res.data.data
            this.$store.commit("setJumpData", {...res.data.data, isApp: true})
            let obj = {
              path: "/project/" + res.data.data.ofoItemId,
              name: "proDetail",
              label: "项目详情",
              ofoItemId: res.data.data.ofoItemId,
              children: []
            };
            this.menuList.forEach(el => {
              if(obj.path.indexOf(el.path) != -1) {
                this.$store.commit('setSecondMenu', el.children)
              }
            });
            this.$store.commit("selectMenu", obj);
          }

        })
      },
      async handleExpand(row) {
        this.$refs.table.toggleRowExpansion(row)

        // 查询活动及资源
        if(!row.workFlag){
          const workId = row.ofoworkId
          row.workDetail = {}
          await this.$http.get(url.getOfoFlowWorkByOfoWorkId + workId).then(res => {
            row.workDetail.ofoFlowWork = res.data.data || {}
          })
          if(!row.workDetail.ofoFlowWork || Object.keys(row.workDetail.ofoFlowWork).length < 1 ){
            return
          }
          await this.$http.get(url.getOfoFlowDealById + row.workDetail.ofoFlowWork.ofodealId).then(res => {
            row.workDetail.ofoFlowDeal = res.data.data || {}
          })
          if(row.workDetail.ofoFlowWork.checkConfig) {
            await this.$http.get(url.getItemWorkConfig, {params: {
                ofoflowworkId: row.workDetail.ofoFlowWork.ofoFlowWorkId
              }}).then(res => {
              if(res.data.code == 200) {
                row.workDetail.workConfig = res.data.data
              }
            })
          }else {
            row.workDetail.workConfig = {}
          }
          if(row.workDetail.ofoFlowWork.kindtype && row.workDetail.ofoFlowWork.workkindmanagetype != '0') {
            await this.$http.get(url.getWorkResAndThingList, {params: {
                ofoWorkId: workId,
                pageNum: 1,
                pageSize: 2000,
                type: '1'
              }}).then(res => {
              if(res.data.code == 200) {
                let productsList = handleWorkConfigList(row.workDetail.ofoFlowWork.checkConfig, res.data.data.list, row.workDetail.workConfig)
                productsList.forEach(item => {
                  item.bomId = item.bomId ? Number(item.bomId) : null
                })
                row.workDetail.productsList = productsList
              }
            })
          }
          if(row.workDetail.ofoFlowWork.thingtype && row.workDetail.ofoFlowWork.workkindmanagetype != '0') {
            await this.$http.get(url.getWorkResAndThingList, {params: {
                ofoWorkId: workId,
                pageNum: 1,
                pageSize: 2000,
                type: '2'
              }}).then(res => {
              if(res.data.code == 200) {
                row.workDetail.thingsList = handleWorkConfigList(row.workDetail.ofoFlowWork.checkConfig, res.data.data.list, row.workDetail.workConfig)
              }
            })
          }
          row.workFlag = true
          this.productViewKey = this.productViewKey + 1
        }
      },
      expandChange(row, expandedRows) {
        if(expandedRows.length) {
          this.tableData.map(async (item, index) => {
            if(item.osAppId == row.osAppId) {
              let stepData = []
              await this.$http.get(url.getMyOsAppStep, {params: {osappId: row.osAppId}}).then(res => {
                if(res.data.code == 200) {
                  stepData = res.data.data
                }

              })
              this.tableData[index].stepData = stepData
            }
          })
        }
      },
      onSubmit() {
        this.pageNum = 1
        this.getList()
      },
      reset() {
        for(let key in this.queryParams) {
          this.queryParams[key] = null
        }
        this.date = []
        this.date2 = []
        this.onSubmit()
      },
    },
    watch: {
      currentMenu: {
        handler(newValue, oldValue) {
        // console.log(newValue);
          this.getList()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.approval {
  padding: 16px;
  .list {
    width: calc(100% - 32px);
    padding: 16px;
    background-color: #fff;
    min-height: calc(100% - 32px);
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,1);
    border-radius: 11px;
    box-sizing: content-box;
    overflow: auto;
    .title {
      height: 14px;
      font-size: 14px;
      font-family: STHeitiSC-Medium, STHeitiSC;
      font-weight: 500;
      color: #282828;
      line-height: 15px;
      padding-left: 8px;
      border-left: #0C75E5 2px solid;
      margin-bottom: 16px;
      font-weight: bolder;
    }
    .el-table {
      margin-bottom: 39px;
      .step {
        border: 1px solid #337ab7;
        padding: 0 5px;
        border-radius: 4px;
        color: #337ab7;
        cursor: pointer;
      }
      .step:hover {
        color: #ffffff;
        background-color: #337ab7;
      }
      /* .el-button {
        color: #0c75e5;
        border: 0;
        padding: 0;
      } */
      ::v-deep .el-table__expand-icon {
        //display: none;
      }
    }
    .el-card {
      margin-bottom: 16px;
      margin-left: 8px;
      box-shadow: 0px 0px 5px 0px rgba(197,197,197,0.5);
      border-radius: 7px;
      border: 0;
      position: relative;
      ::v-deep .el-card__body {
        padding: 13px 11px;
      }
      ::v-deep .el-descriptions-item__label {
        width: 60px;
        margin-right: 8px;
      }
      ::v-deep .el-descriptions__table tbody:last-child td {
        padding-bottom: 0;
      }
      .el-button {
        width: 49px;
        height: 19px;
        background: #D5E9FF;
        border-radius: 4px;
        border: 1px solid #0C75E5;
        font-size: 11px;
        font-family: STHeitiSC-Light, STHeitiSC;
        font-weight: 300;
        color: #0C75E5;
        line-height: 19px;
        padding: 0;
        position: absolute;
        right: 16px;
        top: 50%;
        margin-top: -9px;
      }
    }
  }
}
::v-deep .el-dialog {
  margin: 0 auto;
  max-height: calc(100% - 72px);
  // height: calc(100% - 72px);
}
::v-deep .el-dialog__body {
  /* padding: 10px 0 10px 20px; */
  /* margin-right: 20px; */
  max-height: calc(100vh - 246px);
  // height: calc(100vh - 206px);
  overflow: auto;
}
</style>
